<template>
  <div class="finish-container">
    <div>
      <img class="success-icon" :src="isZHXH?uploadSuccessGreen:uploadSuccess" alt="" />
      <p class="second">{{ `${second}秒后自动关闭` }}</p>
    </div>
  </div>
  <p class="tips">
    关闭弹窗后可在表单中查看。
  </p> 
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { IsZhiHuiXingHe } from "@/core/hooks/SetTheme";
export default defineComponent({
  name: "FinishImport",
});
</script>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from "vue";
import uploadSuccess from "@/assets/images/icon-upload-success.png"
import uploadSuccessGreen from "@/assets/images/icon-upload-success-green.png"
const emit = defineEmits(["handleClose"]);
const isZHXH=IsZhiHuiXingHe()
const props = defineProps({
  backPage: {
    type: String,
  },
});

const second = ref(3);
let timer;
onMounted(() => {
  timer = setInterval(() => {
    second.value--;
    if (second.value <= 0) {
      clearInterval(timer);
      emit("handleClose");
    }
  }, 1000);
});

onUnmounted(() => {
  timer && clearInterval(timer);
});
</script>

<style lang="less" scoped>
.finish-container {
  text-align: center;
  margin: 40px 0 10px;
  height: calc(100% - 132px);
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .success-icon {
    display: block;
    width: 180px;
    height: 180px;
    margin: 0 auto 16px;
  }
  .second {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
  }
}

.tips {
  text-align: center;
  color: #aaaaaa;
  margin: 20px 0;
  font-size: 14px;
  .ant-btn {
    padding: 0;
    color: #4473fc;
  }
}
</style>
